export default {
    setInstalledPluginsData(state, payload){
        console.log("payloadpayload",payload)
        state.installedPlugins = payload
    },
};